import * as React from 'react';
import { Redirect, Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import { ProgramHomePageTypes } from 'bundles/enterprise-legacy-learner-home/constants/ProgramHomeConstants';
import RouteNames from 'bundles/enterprise-legacy-learner-home/constants/RouteNames';
import ProgramSkillRecommendationsPageRoot from 'bundles/program-skills-objectives/pages/ProgramSkillRecommendationsPageRoot';
import ProgramSkillSetSkillRecommendationsPageRoot from 'bundles/program-skills-objectives/pages/ProgramSkillSetSkillRecommendationsPageRoot';
import EnterprisePageWrapper from 'bundles/unified-home-common/pages/enterprise/EnterprisePageWrapper';

const ProgramSkillsObjectivesPageRoot = loadOnRoute(
  () => import('bundles/program-skills-objectives/pages/ProgramSkillsObjectivesPageRoot')
);

const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

const routes = (
  <CourseraRoute
    handle={{
      tracking: {
        data: (params) => ({
          page: { segment: 'enterprise' },
          enterprise: {
            organizationSlug: params?.orgSlug,
            ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
          },
        }),
      },
    }}
  >
    <CourseraRoute
      name={RouteNames.PROGRAM_HOME}
      path="programs(/:programSlug)"
      component={EnterprisePageWrapper}
      handle={{
        tracking: {
          data: (_, location) => {
            const currentTab = location?.query?.currentTab as keyof typeof ProgramHomePageTypes;

            return {
              page: { type: ProgramHomePageTypes[currentTab] ?? ProgramHomePageTypes.CATALOG },
            };
          },
        },
      }}
    >
      <Redirect from="objectives/:objectiveSlug" to="skillsets/:objectiveSlug" />
      <CourseraRoute
        name={RouteNames.OBJECTIVES}
        path="skillsets/:objectiveSlug"
        getComponent={ProgramSkillsObjectivesPageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: { type: ProgramHomePageTypes.PROGRAM_SKILLSETS },
            }),
          },
        }}
      />
      <CourseraRoute
        name={RouteNames.SKILLSET_SKILL_RECOMMENDATIONS}
        path="skillsets/:objectiveSlug/skill/:skillId"
        component={ProgramSkillSetSkillRecommendationsPageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: { type: ProgramHomePageTypes.PROGRAM_SKILLSETS },
            }),
          },
        }}
      />
      <CourseraRoute
        name={RouteNames.SKILL_RECOMMENDATIONS}
        path="skills/:skillId"
        component={ProgramSkillRecommendationsPageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: { type: ProgramHomePageTypes.PROGRAM_SKILLS },
            }),
          },
        }}
      />
    </CourseraRoute>
    <Route path="*" getComponent={NotFound} />
  </CourseraRoute>
);

export default routes;
